// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"DePiKM","errorMessage":"HVFlED","errorIcon":"JvVriV"};